<template>
  <v-app>
    <v-main class="main-background">
      <v-container class="main-container">
        <AppHeader :logoPath="logoPath" />
        <div class="content-area">
          <div>
            <div class="tabbed-area-container">
              <v-row>
                <v-col cols="auto" class="col-1">
                  <v-list-item-title>ニュース</v-list-item-title>
                </v-col>
                <v-col cols="auto" class="col-2">
                  <a @click.prevent="navigateBackNumber" href="#" style="text-decoration: none;">
                    バックナンバーを見る<br />
                    (10日前まで)
                  </a>
                </v-col>
                <v-col cols="auto" class="col-3">
                  <v-tabs v-model="activeTab">
                    <v-tab
                      v-for="(tab, index) in tabs"
                      :key="tab"
                      :style="
                        index !== tabs.length - 1
                          ? 'border-right: 1px solid #ccc; padding: 0 5px; font-size: 12px;'
                          : 'padding: 0 10px; font-size: 12px;'
                      "
                      :class="{ 'active-tab': activeTab === index }"
                      >{{ tab }}</v-tab
                    >
                  </v-tabs>
                </v-col>
                <v-col cols="auto" class="col-4">
                  <multiselect
                    v-model="selectedRegion"
                    :options="availableOptions"
                    placeholder=""
                    :searchable="true"
                    :preserve-search="true"
                    @select="handleSelect"
                    class="custom-multiselect-width"
                    :show-labels="false"
                    style="width: 9em;"
                  >
                    <template v-slot:noResult>
                      <span>{{ "結果無し" }}</span>
                    </template>
                  </multiselect>
                </v-col>
              </v-row>
              <div v-if="dialogMessage" class="error-message">
                {{ dialogMessage }}
              </div>
              <v-list class="scrollable-list">
                <template v-if="filteredNewsData.length > 0">
                  <v-list-item
                    v-for="(item) in filteredNewsData.slice(0, 5)"
                    :key="item.article_id"
                    class="list-item"
                    style="border-bottom: 1px solid #ccc"
                  >
                    <v-row>
                      <v-col :cols="2">
                        <span
                          class="responsive-font"
                          style="font-size: 15px; color: gray"
                        >
                          <template v-if="isMoreNarrowScreen">
                            {{ item.publish_date.split("-")[0] }}/<br />{{
                              item.publish_date.split("-")[1]
                            }}/{{ item.publish_date.split("-")[2] }}
                          </template>
                          <template v-else>
                            {{ item.publish_date }}
                          </template>
                        </span>
                      </v-col>
                      <v-col :cols="isNarrowScreen ? 1.3 : 1">
                        <span 
                          v-if="item.regions.length === 0" 
                          class="responsive-font region-tag" 
                          style="font-size: 15px; display: block;"
                        >
                          全国
                        </span>
                        <span 
                          v-for="(region, index) in item.regions" 
                          :key="index" 
                          class="responsive-font region-tag" 
                          style="font-size: 15px; display: block;"
                        >
                          {{ region }}{{ index < item.regions.length - 1 ? ',' : '' }}
                        </span>
                      </v-col>
                      <v-col :cols="isNarrowScreen ? 1.3 : 1">
                        <span
                          v-if="item.industries.length === 0" 
                          class="responsive-font industry-tag"
                          style="font-size: 15px; display: block;"
                          >
                          (業界カテゴリなし)
                        </span>
                        <span
                          v-else
                          v-for="(industry, index) in item.industries"
                          :key="index"
                          class="responsive-font industry-tag"
                          :style="{
                            fontSize: '15px',
                            color: getTagColor(industry),
                            marginRight: index < item.industries.length - 1 ? '5px' : '0',
                            display: 'block'
                          }"
                        >
                          {{ industry }}{{ index < item.industries.length - 1 ? ',' : '' }}
                        </span>
                      </v-col>
                      <v-col :cols="isNarrowScreen ? 7 : 8">
                        <div class="d-flex align-center">
                          <div v-if="item.article_id">
                            <router-link
                              :to="{ name: 'NewsDetail', params: { article_id: item.article_id } }"
                              class="truncate-title"
                              target="_blank"
                            >
                              <span>{{ item.title || '(タイトルなし)' }}</span>
                            </router-link>
                          </div>
                          <div v-else>
                            <span>{{ item.title || '(タイトルなし)' }}</span>
                          </div>
                        </div>
                        <div class="d-flex align-center pa-1">
                          <v-btn
                            @click="navigateAgreementPage(item.article_id)"
                            style="
                              background-color: lightblue;
                              border-radius: 15px;
                              padding: 4px 8px;
                              font-size: 12px;
                              height: 24px;
                            "
                          >
                            営業トーク例作成
                          </v-btn>
                          <div style="width: 2em"></div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>
                <template v-else>
                  <v-list-item class="list-item">
                    <v-row>
                      <v-col cols="12" class="text-center">
                        <span style="color: gray;">{{ newsListMessage }}</span>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>
              </v-list>
            </div>
          </div>
          <v-row style="max-width: 850px; margin: 0 auto;">
            <v-col>
              <div class="youtube-video">
                <iframe
                  src="https://www.youtube.com/embed/xCmKs12J8qc"
                  frameborder="0"
                  allowfullscreen
                  style="width: 100%; height: 100%;"
                >
                </iframe>
              </div>
            </v-col>
            <v-col>
              <div class="overlay-container" style="display: flex; justify-content: center; align-items: center; height: 100%; margin-top: -1px;">
                <a href="https://app.box.com/folder/207064940138" target="_blank">
                  <div style="display: flex; justify-content: center; position: relative;">
                    <img
                      :src="greenButtonPath"
                      alt="External Image"
                      width="100%"
                      height="280"
                      style="border-radius: 10px"
                      />
                    <div>
                      <img
                      :src="iconFeatherFileTextPath"
                      alt="Overlay Image 1"
                      class="document-icon"
                      style="position: absolute; top: 15%; left: 18%; transform: translate(-50%, -50%);"
                      />
                    </div>
                    <div>
                      <div
                      class="green-band-text"
                      style="position: absolute; top: 50%; left: 25%; transform: translate(-15%, -50%);"
                      >
                        セールスファイルを作成する
                      </div>
                    </div>
                    <div>
                      <img
                      :src="greenArrowPath"
                      alt="Overlay Image 2"
                      class="circle-button-icon"
                      style="position: absolute; top: 89%; left: 82%; transform: translate(-50%, -50%);"
                      />
                    </div>
                  </div>
                </a>
              </div>
            </v-col>
          </v-row>
          <div class="image-grid-flame">
            <v-container>
              <div class="image-grid">
                <div v-for="(image, index) in images" :key="index">
                  <a :href="image.href" target="_blank" class="image">
                    <img
                      :src="image.src"
                      :alt="image.alt"
                      class="responsive-image"
                    />
                  </a>
                </div>
              </div>
              <div class="link-grid">
                <div v-for="(link, index) in links" :key="index">
                  <div class="link">
                    <a :href="link.href" target="_blank">
                      <img
                        :src="whiteButtonPath"
                        :alt="link.alt"
                        class="responsive-link"
                      />
                      <div class="grid-text">{{ link.text }}</div>
                    </a>
                  </div>
                </div>
              </div>
            </v-container>
          </div>
          <AppFooter />
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { fetchNews } from "@/api";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import { errorMessages } from '@/constants/errorMessages.js';
import { inject } from 'vue';

const newsData = ref([]);
let gtm = null;


//--------------------------------------------------------------------------------
// FastAPIへのアクアセステスト
// import { gapi } from "gapi-script";
// import { GoogleAuth } from "google-auth-library"; // 追加
//--------------------------------------------------------------------------------

export default {
  components: {
    AppHeader,
    AppFooter,
    Multiselect,
  },
  setup() {
    const router = useRouter();
    const apiNewsData = ref([]);
    const cannotGenerateDialog = ref(false);
    const isNarrowScreen = ref(window.innerWidth < 700);
    const isMoreNarrowScreen = ref(window.innerWidth < 600);
    const dialogMessage = ref('');
    const newsListMessage = ref('');

    const navigateAgreementPage = (newsId) => {
      gtm?.sendAiTalkButtonEvent()
      window.open(router.resolve({ name: "UsageAgreement", params: { article_id: newsId } }).href, '_blank');
    };

    const navigateBackNumber = () => {
      const route = router.resolve({ name: 'BackNumber' });
      window.open(route.href, '_blank');
    };

    onMounted(async () => {
      gtm = inject('$gtm');
      try {
        newsListMessage.value = "ニュースデータ読み込み中。";
        const response = await fetchNews();
        if (response.status === 200) {
          newsListMessage.value = "ニュースデータがありません。";
          if (response.data.errno !== undefined) {
            dialogMessage.value = errorMessages.e01101(response.data.errno, response.status);
          }
          else {
            const data = response.data;
            // エラーデータを除外
            const validData = data.filter(item => item.article_id);

            // 14日以上前のニュースが存在する場合
            if (validData.some(item => new Date(item.publish_date) < new Date(Date.now() - 14 * 24 * 60 * 60 * 1000))) {
                dialogMessage.value = errorMessages.e01102;
            }
            else {
              // 正常なデータ
              apiNewsData.value = validData;
            }
          }

        } else {
          dialogMessage.value = errorMessages.e01101(response.data.errno, response.status);
          console.error('HTTPステータス:', response.status);
          console.error('エラー番号:', response.data.errno);
          console.error('エラーメッセージ:', response.data.errmsg);
        }
      } catch (error) {
        if (error.response) {
          dialogMessage.value = errorMessages.e01101(error.response.data.errno, error.response.status);
          console.error('HTTPステータス:', error.response.status);
          console.error('エラー番号:', error.response.data.errno);
          console.error('エラーメッセージ:', error.response.data.errmsg);
        }
      }
    });

    return {
      cannotGenerateDialog,
      isNarrowScreen,
      isMoreNarrowScreen,
      navigateAgreementPage,
      navigateBackNumber,
      dialogMessage,
      apiNewsData,
      newsListMessage,
    };
  },
  data() {
    const contentsStorage = process.env.VUE_APP_CONTENTS_STORAGE;

    return {
      clicked: false,
      logoPath: require("@/assets/page_title.png"),
      greenButtonPath: require("@/assets/green_button.png"),
      iconFeatherFileTextPath: require("@/assets/Icon feather-file-text.png"),
      greenArrowPath: require("@/assets/green_arrow.png"),

      image1Path: require("@/assets/image1.png"),
      image2Path: require("@/assets/image2.png"),
      image3Path: require("@/assets/image3.png"),
      image4Path: require("@/assets/image4.png"),
      image5Path: require("@/assets/image5.png"),
      image6Path: require("@/assets/image6.png"),
      images: [
        {
          href: "https://www.sej.co.jp/company/assets_2025/images/yokogao_pdf.pdf",
          src: require("@/assets/image1.png"),
          alt: "Image 1",
        },
        {
          href: `${contentsStorage}/pdf/2025%E5%87%BA%E5%BA%97%E3%81%AE%E3%81%94%E6%A1%88%E5%86%85%EF%BC%88%E3%83%9A%E3%83%BC%E3%82%B8%E5%88%86%E5%89%B2%E7%89%88%EF%BC%89.pdf`,
          src: require("@/assets/image2.png"),
          alt: "Image 2",
        },
        {
          href: "https://www.sej.co.jp/company/",
          src: require("@/assets/image3.png"),
          alt: "Image 3",
        },
        {
          href: "https://www.7andi.com/group/quarterly/",
          src: require("@/assets/image4.png"),
          alt: "Image 4",
        },
        {
          href: "https://www.sej.co.jp/products/anshin.html",
          src: require("@/assets/image5.png"),
          alt: "Image 5",
        },
        {
          href: "https://www.sej.co.jp/csr/",
          src: require("@/assets/image6.png"),
          alt: "Image 6",
        },
      ],
      links: [
        {
          href: "https://www.jfa-fc.or.jp/fc-g-misc/pdf/71-2.pdf",
          alt: "Link Image 1",
          text: "フランチャイズ契約の要点と概説",
        },
        {
          href: "https://www.sej.co.jp/products/",
          alt: "Link Image 1",
          text: "商品",
        },
        {
          href: "https://www.sej.co.jp/csr/news.html",
          alt: "Link Image 1",
          text: "サステナビリティ\nアクション",
        },
        {
          href: "https://www.sej.co.jp/owner/contents/owner-interview/?utm_source=yahoo&utm_medium=cpc&utm_campaign=kw_brand&utm_content=interview&yclid=YSS.1001060937.EAIaIQobChMI55X4nbyNiQMVgg97Bx2f7QC2EAAYASABEgK_1_D_BwE",
          alt: "Link Image 1",
          text: "オーナー\nインタビュー", 
        },
        {
          href: "https://www.sej.co.jp/concept.html",
          alt: "Link Image 1",
          text: "4VISIONS",
        },
        {
          href: "https://www.7andi.com/ir/",
          alt: "Link Image 1",
          text: "株主・投資家(IR)",
        },
      ],
      whiteButtonPath: require("@/assets/white_button.png"),
      linkCopyButtonPath: require("@/assets/link_copy_icon.png"),

      activeTab: 0,
      tabs: ["全て", "小売・飲食", "建設・不動産", "食品", "金融", "運輸", "公的機関・大学"],
      newsData,
      regions: [
        "全国",
        "北海道",
        "東北地方",
        "北陸地方",
        "北関東地方",
        "首都圏",
        "中部地方",
        "東海地方",
        "近畿地方",
        "中国地方",
        "四国地方",
        "九州地方・沖縄"
      ],
      selectedRegion: "全国",
      filteredOptions: [],
    };
  },
  methods: {
    onSearch(search) {
      this.search = search;
    },
    handleSelect(selectedRegion) {
      this.selectedRegion = selectedRegion;
    },
    getTagColor(tag) {
      switch (tag) {
        case "小売・飲食":
          return "deepskyblue";
        case "建設・不動産":
          return "brown";
        case "食品":
          return "green";
        case "金融":
          return "gold"
        case "運輸":
          return "orange";
        case "公的機関・大学":
          return "red";
        default:
          return "black";
      }
    },
  },
  computed: {
    availableOptions() {
      // 選択されている項目をリストから除外
      return this.regions.filter((option) => option !== this.selectedRegion);
    },
    filteredNewsData() {
      // apiNewsDataを使用するように変更
      let filteredData = this.apiNewsData;
      // タブによる絞り込み
      if (this.activeTab !== 0) {
        const category = this.tabs[this.activeTab];
        filteredData = filteredData.filter(item => item.industries.includes(category));
      }

      // 地域による絞り込み
      if (this.selectedRegion !== "全国") {
        filteredData = filteredData.filter(item => item.regions.includes(this.selectedRegion));
      }
      
      return filteredData;
    },
  },
  watch: {
    search(newSearch) {
      this.filteredOptions = this.options.filter((option) =>
        option.toLowerCase().includes(newSearch.toLowerCase())
      );
    },
  },
  created() {
    this.filteredOptions = this.options;
  },
};
</script>

<style scoped>
/* -----------------------------------全体用----------------------------------- */
/* フォントを統一 */
html {
  font-family: "Hiragino Sans", sans-serif;
}
body,
html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #f0f0f0; /* 背景色を薄いグレーに設定 */
}

.main-background {
  background-color: #f0f0f0; /* 背景色を薄いグレーに設定 */
  width: 100%;
  min-height: 100vh;
}

.main-container {
  background-color: #f0f0f0; /* メインコンテナの背景色を白に設定 */
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content-area {
  flex: 1;
  background-color: #f0f0f0; /* コンテンツエリアの背景色を白に設定 */
}

/* -----------------------------------ヘッダ部分----------------------------------- */
/* ヘッダー部分の色と下部とのマージン */
header {
  background-color: #ffffff;
  margin-bottom: 10px;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  position: relative;
}

.logo img {
  width: 277px;
  height: 50px;
  padding: 5px;
  margin-top: 5px;
}

.logo {
  margin-left: 16%;
}
/* -----------------------------------ニュースエリア部分----------------------------------- */
/* ニュースエリアの細かい調整用 */
.tabbed-area-container {
  background-color: #f5f5f5;
  padding: 10px;
  border: 1px solid #ccc;
  margin: 10px auto;
  width: 850px;
  max-width: calc(100% - 20px);
}

/* ニュースエリアのタブの調整 */
.tab-container {
  margin-top: 20px;
  text-align: center;
}

.v-tab.active-tab {
  font-weight: bold !important;
}

.v-tab {
  min-width: auto;
  font-size: 0.8em;
  padding: 0; /* 上下の空白をなくす */
  margin: 0; /* 左右の空白をなくす */
}

.truncate-title {
  display: block;
  width: 100%;
  white-space: normal;
  overflow: hidden;
  word-break: break-all;
}

.tab {
  padding: 10px 20px;
  cursor: pointer;
  background-color: #f0f0f0;
  border: none;
  outline: none;
  transition: background-color 0.3s;
}

.tab:hover {
  background-color: #ddd;
}

.custom-multiselect-width {
  width: 10em;
}

::v-deep .multiselect__option,
::v-deep .multiselect__single,
::v-deep .multiselect__placeholder {
  font-size: 1em;
}

.scrollable-list {
  max-height: 400px;
  overflow-y: scroll;
  width: 100%;
  border: 1px solid #ccc;
}

/* 他の列の幅を調整 */
.v-list-item .v-row .v-col:first-child {
  flex-basis: 14% !important;
  max-width: 30% !important;
}

/* 2列目と3列目の幅を広げる */
.v-list-item .v-row .v-col:nth-child(2){
  flex-basis: 15% !important;
  max-width: 15% !important;
}

.v-list-item .v-row .v-col:nth-child(3) {
  flex-basis: 21% !important;
  max-width: 30% !important;
}

.v-list-item .v-row .v-col:last-child {
  flex-basis: 50% !important;
  max-width: 50% !important;
}

@media (max-width: 640px) {
  .tabbed-area-container .col-1 {
    order: 1;
  }

  .tabbed-area-container .col-2 {
    order: 2;
  }

  .tabbed-area-container .col-3 {
    order: 3;
  }

  .tabbed-area-container .col-4 {
    order: 2; /* これで右上に配置されます */
    align-self: flex-end;
    margin-left: auto;
    width: auto;
  }
  
  /* レスポンシブ対応 */
  .v-list-item .v-row .v-col {
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
}
/* -----------------------------------緑帯ボタン部分----------------------------------- */
/* 書類ロゴの位置 */
.document-icon {
  position: absolute;
  width: 50px;
  height: 70px;
  top: 50%;
  left: 18%;
  transform: translate(-50%, -50%);
}

/* 丸ボタン矢印の位置 */
.circle-button-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 82%;
  transform: translate(-50%, -50%);
}

.green-band-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 32px;
}

@media (max-width: 824px) {
  .green-band-text {
    font-size: 30px; /* 横幅700px以下の場合にフォントサイズを小さくする */
  }
  .document-icon {
    position: absolute;
    width: 40px;
    height: 60px;
  }
  .circle-button-icon {
    position: absolute;
    width: 40px;
    height: 40px;
  }
}
@media (max-width: 773px) {
  .green-band-text {
    font-size: 23px; /* 横幅700px以下の場合にフォントサイズを小さくする */
  }
  .document-icon {
    position: absolute;
    width: 35px;
    height: 50px;
  }
  .circle-button-icon {
    position: absolute;
    width: 35px;
    height: 35px;
  }
}

.overlay-container {
  margin-top: 10px;
  position: relative;
}

.overlay-container a:hover {
  opacity: 0.7;
}
/* -----------------------------------Youtube部分----------------------------------- */
.youtube-video {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px; /* 上のマージンを調整 */
  margin-bottom: 15px; /* 下のマージンを調整 */
}

.youtube-video iframe {
  max-width: 500px; /* iframeの幅を親要素に合わせる */
  width: 100%;
  height: auto; /* 高さを自動調整 */
  aspect-ratio: 16/9; /* 縦横比を16:9に保持 */
}
/* -----------------------------------リンクグリッド部分----------------------------------- */
.image-grid-flame {
  background-color: #ffffff;
  display: flex;
  text-align: center;
  justify-content: center;
  margin-top: 0;
  margin-bottom: 25px;
  margin-left: auto;
  margin-right: auto;
  width: 900px;
  max-width: calc(100% - 20px);
  border: solid 1px #cccccc;
}
@media (max-width: 641px) {
  .image-grid-flame {
    margin-bottom: 50px;
  }
}

@media (max-width: 600px) {
  .image-grid-flame .v-col {
    flex: 0 0 33.33%; /* 各列を3分の1の幅に設定 */
    max-width: 33.33%;
  }
}

.responsive-image {
  width: 100%;
  height: auto;
  max-width: 256px;
  min-width: 100px;
}

.responsive-link {
  width: 100%;
  height: auto;
  max-width: 256px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.link-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.image-grid .image:hover img {
  opacity: 0.7;
}

.link {
  position: relative;
}

.link img {
  border-bottom: solid 1px #008833;
}

.link a {
  display: block;
}

.link:hover {
  opacity: 0.7;
}

.grid-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-size: 15px;
  width: 9em;
  text-align: center;
  white-space: pre-line;
}
@media (max-width: 700px) {
  .grid-text {
    font-size: 12px; /* 横幅700px以下の場合にフォントサイズを小さくする */
  }
}
/* -----------------------------------エラーメッセージ部分----------------------------------- */
.error-message {
  color: red;
  text-align: center;
  margin: 10px 0;
  padding: 10px;
  font-weight: bold;
}
/* -----------------------------------フッター部分----------------------------------- */
.footer {
  padding: 5px;
  font-size: 14px;
  color: #000000;
  background: #cccccc;
  border-top: 1px solid #e5e7eb;
  text-align: center;
  width: 100%;
  box-sizing: border-box; /* パディングを含めて幅を計算 */
  position: absolute;
  bottom: 0;
  left: 0;
}
.full-width {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
}
.footer-text {
  color: #000;
  font-weight: bold;
  font-size: 14px;
}

.industry-tag {
  display: inline-block;
  padding: 2px 5px;
  border-radius: 3px;
  margin-bottom: 2px;
}

.region-tag {
  display: inline-block;
  margin-right: 2px;
}
</style>
